import React, { Component } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBCard,
  MDBCardBody,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";

import defaultImg from "images/muginlogo.jpg";

import "./NewsDetail.css";

const toDataUri = (b64) => (b64 ? `data:image/jpeg;base64,${b64}` : "");
const NEWS_FORMAT_KEY = "ratio:16:9";

export default class NewsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticia: null,
      loading: true,
    };
  }

  componentDidMount() {
    const slug = this.getSlugFromUrl();
    if (slug) {
      this.loadNoticia(slug);
    } else {
      this.setState({ loading: false });
    }
  }

  getSlugFromUrl() {
    const path = window.location.pathname;
    const match = path.match(/\/noticia\/([^/]+)$/);
    return match ? match[1] : null;
  }

  async loadNoticia(slug) {
    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch("MUGIN", "getNoticia?slug=" + encodeURIComponent(slug), { method: "GET" });
      const data = await response.json();
      if (data && data.STATE === "SUCCESS" && data.DATA) {
        this.setState({ noticia: data.DATA });
      } else {
        this.setState({ noticia: null });
      }
    } catch (error) {
      console.error("Error al cargar noticia:", error);
      this.setState({ noticia: null });
    } finally {
      this.setState({ loading: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  onBack = () => {
    if (this.props.onHandleNavLinks) {
      this.props.onHandleNavLinks({ force: "Home" }, "/");
    }
  };

  render() {
    const { noticia, loading } = this.state;

    if (loading) return null;

    if (!noticia) {
      return (
        <div className="news-detail">
          <button className="back-link" onClick={this.onBack}>
            ← Volver
          </button>
          <div className="text-center my-5">
            <h3>Noticia no encontrada</h3>
            <p className="text-muted">La noticia que buscas no existe o ha sido eliminada.</p>
          </div>
        </div>
      );
    }

    const imageSrc = noticia.imageUuid
      ? mfmFramedUrl(noticia.imageUuid, 1280, 720, NEWS_FORMAT_KEY)
      : noticia.base64img
        ? toDataUri(noticia.base64img)
        : defaultImg;

    const fechaFormatted = noticia.fecha
      ? new Date(noticia.fecha).toLocaleDateString("es-ES", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "";

    const hasFullText = noticia.texto && noticia.texto.trim().length > 0;
    const hasShortText = noticia.textoCorto && noticia.textoCorto.trim().length > 0;

    return (
      <div className="news-detail">
        <button className="back-link" onClick={this.onBack}>
          ← Volver
        </button>

        {/* Hero image */}
        <div className="news-detail-hero mb-4">
          <img
            className="news-detail-hero-img"
            src={imageSrc}
            alt={noticia.titulo}
            draggable={false}
          />
          <div className="news-detail-hero-overlay">
            <h1 className="news-detail-hero-title">{noticia.titulo}</h1>
            {fechaFormatted && (
              <p className="news-detail-hero-date">
                <MDBIcon far icon="calendar-alt" className="me-2" />
                {fechaFormatted}
              </p>
            )}
          </div>
        </div>

        {/* Content area */}
        <MDBContainer className="news-detail-content">
          {/* Short text as lead/intro */}
          {hasShortText && (
            <MDBRow className="mb-4">
              <MDBCol md="10" lg="8" className="mx-auto">
                <p className="news-detail-lead">{noticia.textoCorto}</p>
              </MDBCol>
            </MDBRow>
          )}

          {/* Separator */}
          {hasShortText && hasFullText && (
            <MDBRow className="mb-4">
              <MDBCol md="10" lg="8" className="mx-auto">
                <hr className="news-detail-divider" />
              </MDBCol>
            </MDBRow>
          )}

          {/* Full text */}
          {hasFullText && (
            <MDBRow>
              <MDBCol md="10" lg="8" className="mx-auto">
                <div
                  className="news-detail-body"
                  dangerouslySetInnerHTML={{ __html: noticia.texto }}
                />
              </MDBCol>
            </MDBRow>
          )}

          {/* External link card */}
          {noticia.link && (
            <MDBRow className="mt-4 mb-3">
              <MDBCol md="10" lg="8" className="mx-auto">
                <MDBCard className="news-detail-link-card">
                  <MDBCardBody className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                      <MDBIcon icon="link" className="me-2 news-detail-link-icon" />
                      <span className="news-detail-link-text">Enlace relacionado</span>
                    </div>
                    <MDBBtn
                      tag="a"
                      href={noticia.link}
                      target="_blank"
                      rel="noreferrer"
                      className="news-detail-link-btn"
                      size="sm"
                    >
                      <MDBIcon icon="external-link-alt" className="me-2" />
                      Abrir enlace
                    </MDBBtn>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          )}
        </MDBContainer>
      </div>
    );
  }
}
